import React from 'react'
import PropTypes from 'prop-types'

import { hexToRgbA } from '@util/stringUtil'
import colors from '@settings/styleSettings'
import Text from './Text'

export const Status = ({
  textColor,
  text,
  icon,
  style,
  textStyle,
  minWidth,
}) => {
  return (
    <div
      style={{
        backgroundColor: hexToRgbA(textColor, '0.16'),
        borderRadius: '20px',
        padding: '4px 8px',
        height: 20,
        minWidth,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 10,
        fontWeight: 700,
        ...style,
      }}
    >
      {icon && icon(textColor)}
      <Text
        style={{
          marginLeft: icon ? 10 : 0,
          color: textColor,
          fontFamily: 'Inter-Bold',
          ...textStyle,
        }}
      >
        {text}
      </Text>
    </div>
  )
}

Status.propTypes = {
  text: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  icon: PropTypes.func,
  textStyle: PropTypes.shape({}),
  style: PropTypes.shape({}),
  minWidth: PropTypes.number,
}

Status.defaultProps = {
  icon: null,
  textStyle: {},
  textColor: colors.titleStrongBlack,
  minWidth: 34,
  style: null,
}
